<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <div id="map-container" class="pa-4" style="width: 100%;height: 650px;"></div>
      <!--<div id="information" class="information"></div>-->
      <div id="popup" class="ol-popup">
        <a href="#" id="popup-closer" class="ol-popup-closer"></a>
        <div id="popup-content"></div>
    </div>

    <table class="legend_table" v-if="category === 'Project' || category === 'Disaster' || category === 'Location' ">
      <tbody>
        <tr class="legend_row">
          <td v-if="category === 'Project' || category === 'Location' " class="legend_cell"><div class="legend_color" style="border: none;border-radius: 10px;margin-right: 5px;background-color: rgb(233, 30, 99, 0.5);"></div><div class="legend_label">{{ $t('Number of Project Per Province') }}</div></td>
          <td v-if="category === 'Disaster'" class="legend_cell"><div class="legend_color" style="border: none;border-radius: 10px;margin-right: 5px;background-color: rgb(255, 124, 0, 0.5);"></div><div class="legend_label">{{ $t('Number of Disaster Per Province') }}</div></td>
        </tr>        
      </tbody>
    </table>
    <table class="legend_table" v-if="category === 'Asset'">
      <tbody>
        <tr class="legend_row">
          <td class="legend_cell"><div class="legend_color" style="border: none;margin-right: 5px;background-color: rgba(60, 222, 103, 0.5);"></div><div class="legend_label">{{ $t('School') }}</div></td>
          <td class="legend_cell"><div class="legend_color" style="border: none;margin-right: 5px;background-color: rgba(0, 87, 217, 0.5);"></div><div class="legend_label">{{ $t('Irrigation') }}</div></td>
          <!--<td class="legend_label">School</td>-->
          <td class="legend_cell"><div class="legend_color" style="border: none;margin-right: 5px;background-color: rgb(233, 30, 99, 0.5);"></div><div class="legend_label">{{ $t('Hospital') }}</div></td>
          <!--<td class="legend_label">Hospital</td>-->
          <td class="legend_cell"><div class="legend_color" style="height: 1px;margin-right: 5px;border:1px solid #e67300;background-color: #e67300;"></div><div class="legend_label">{{ $t('Road') }}</div></td>
          <!--<td class="legend_label">Road</td>-->
        </tr>        
      </tbody>
    </table>

  </v-container>
</template> 

<script>
  import 'ol/ol.css';
  import GeoJSON from 'ol/format/GeoJSON';
  import Map from 'ol/Map';
  import View from 'ol/View';
  import {fromLonLat/*, toLonLat*/} from 'ol/proj';
  import VectorSource from 'ol/source/Vector';
  import VectorLayer from 'ol/layer/Vector';
  import TileLayer from 'ol/layer/Tile';
  import { Fill, Stroke, Style, Text, Icon } from 'ol/style';
  import { defaults as defaultInteractions, MouseWheelZoom, DoubleClickZoom, DragPan } from 'ol/interaction';

  //import OSM from 'ol/source/OSM';
  
  import laosData from '@/assets/laoPDR.json';
  import roadData from '@/assets/roads_osm.json';

  import Feature from 'ol/Feature';
  import Overlay from 'ol/Overlay';
  import Point from 'ol/geom/Point';
  import Circle from 'ol/geom/Circle';

  //import {toStringHDMS} from 'ol/coordinate';

  export default {
    name: 'DashboardMap',
    props: {
      year: {
        type: Array
      },
      location: {
        type: Array
      },
      category: {
        type: String
      }
    },
    data: () => ({
      map: {},
      laosLayer: {},
      layerToManage:[]
    }),
    watch: {
      year: function(year){
        this.year = year;
        this.updateMap(this.category, this.year);
      },
      category: function(category){
        this.category = category;
        this.updateMap(this.category, this.year);
      }
    },
    mounted: function() {
      this.category = this._props.category;
      this.year = this._props.year;
      this.createMap();
   },
   methods: {
    createMap: function(){

      //Elements that make up the popup.
      const container = document.getElementById('popup');
      const content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');

      //Create an overlay to anchor the popup to the map.

      var overlay = new Overlay({
        element: container,
        autoPan: {
          animation: {
            duration: 250,
          },
        },
      });
    
      /***************** Province Layer *******************************/
  
      var laosSource = new VectorSource({
        features: new GeoJSON().readFeatures(laosData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      this.laosLayer = new VectorLayer({
        renderMode: 'image',
        source: laosSource,
        style: styleLaosFunction
      });

      var defaultStyleLaos = new Style({
        fill: new Fill({
          color: 'white',
        }),
        stroke: new Stroke({
          color: '#DCDCDC',
          width: 1,
        })
      });

      // the style function returns an array of styles for the given feature and resolution.
      // Return null to hide the feature.
      function styleLaosFunction(feature, resolution) {
        return [defaultStyleLaos];
      }

      this.layerToManage.push(this.laosLayer);

      var view = new View({
        center: fromLonLat([0.0009350, 0.000164]),
        zoom: 23.45
      });

      /***************** Map Object*******************************/

      this.map = new Map({
        target: 'map-container',
        layers: [
          this.laosLayer
        ],
        overlays: [overlay],
        view: view
      });

      const marker = new Overlay({
        position: fromLonLat([0.000924, 0.0001795]),
        positioning: 'center',
        element: document.getElementById('marker'),
        stopEvent: false,
      });

      //this.map.addOverlay(marker);
    
      //Add a click handler to the map to render the popup.
      this.map.on('singleclick', function (evt) {
        const coordinate = evt.coordinate;

        const pixel = evt.pixel;
        content.innerHTML = '';
        
        const feature = this.forEachFeatureAtPixel(pixel, function(feature) {
          return feature;
        });
       
      
        overlay.setPosition(coordinate);
      });

      //Add a click handler to hide the popup.
      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };
      
      this.updateMap(this.category, this.year);

    },

    updateMap: function(category, year){
     this.map.on('singleclick', function (evt) {
        const coordinate = evt.coordinate;
        const container = document.getElementById('popup');
      const content = document.getElementById('popup-content');
      const closer = document.getElementById('popup-closer');

        const pixel = evt.pixel;
        content.innerHTML = '';
        
        const feature = this.forEachFeatureAtPixel(pixel, function(feature) {
          return feature;
        });
        
          
       if(category === 'Project'){
          if (feature.get('name_en') === 'P. LOUANGPHABANG') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of project:<span style="font-weight:bold;"> 1 </span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Flood 2018</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 120.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Beneficiary:<span style="font-weight:bold;"> 36 </span></p>';
          content.innerHTML += '<p>Total Woman Beneficiary:<span style="font-weight:bold;"> 2</span></p>';
          content.innerHTML += '<p>Total Household Beneficiary:<span style="font-weight:bold;"> 2 </span></p>';
          }
          else if (feature.get('name_en') === 'P. VIENTIANE') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of project:<span style="font-weight:bold;"> 2 </span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Tropical Cyclone Dianmu (2 times)</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 96.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Beneficiary:<span style="font-weight:bold;"> 3 </span></p>';
          content.innerHTML += '<p>Total Woman Beneficiary:<span style="font-weight:bold;"> 1 </span></p>';
          content.innerHTML += '<p>Total Household Beneficiary:<span style="font-weight:bold;"> 1</span></p>';
          }
           else if (feature.get('name_en') === 'VIENTIANE CAPITAL') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of project:<span style="font-weight:bold;"> 1 </span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Flood 2018</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 120.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 36 </span></p>';
          content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 2</span></p>';
          content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 2</span></p>';
          }
          else{
            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of project:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> /</span></p>';
        }
      }
       if(category === 'Disaster'){
          if (feature.get('name_en') === 'P. LOUANGPHABANG') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 3 </span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Cyclone (2 times)</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 147.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 54 </span></p>';
          content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 25</span></p>';
          content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;">20</span></p>';
          }
      
           else if (feature.get('name_en') === 'VIENTIANE CAPITAL') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> 1</span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> Flood 2018</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 120.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> 41 </span></p>';
          content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> 20 </span></p>';
          content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> 15</span></p>';
          content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> 302</span></p>';
          }
          else{
            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> /</span></p>';
        }
      }
       if(category === 'Asset'){
          if (feature.get('name_en') === 'P. LOUANGPHABANG') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of asset:<span style="font-weight:bold;"> 1 </span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;">Tropical Cyclone Dianmu</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 6.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Beneficiary:<span style="font-weight:bold;"> 60 </span></p>';
          content.innerHTML += '<p>Total Woman Beneficiary:<span style="font-weight:bold;"> 20</span></p>';
          content.innerHTML += '<p>Total Household Beneficiary:<span style="font-weight:bold;"> 20</span></p>';
          }
      
           else if (feature.get('name_en') === 'P. PHONGSALI') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of asset:<span style="font-weight:bold;"> 1</span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;">Flood 2018</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 52.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Beneficiary:<span style="font-weight:bold;"> 462</span></p>';
          content.innerHTML += '<p>Total Woman Beneficiary:<span style="font-weight:bold;"> 295</span></p>';
          content.innerHTML += '<p>Total Household Beneficiary:<span style="font-weight:bold;"> 200</span></p>';
          }
          else if (feature.get('name_en') === 'P. HOUAPHAN') {
          content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
          content.innerHTML += '<p>Number of project:<span style="font-weight:bold;"> 1</span></p>';
          content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;">Tropical Cyclone Dianmu</span></p>';
          content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> 6.000 mLAK</span></p>';
          content.innerHTML += '<p>Total People Beneficiary:<span style="font-weight:bold;"> 60</span></p>';
          content.innerHTML += '<p>Total Woman Beneficiary:<span style="font-weight:bold;"> 20</span></p>';
          content.innerHTML += '<p>Total Household Beneficiary:<span style="font-weight:bold;"> 20</span></p>';
          }
          else{
            content.innerHTML =  '<p>Province:<span style="font-weight:bold;">'+ feature.get('name_en') +'</span></p>';
            content.innerHTML += '<p>Number of disaster:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Most disaster occured:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total cost:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total People Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Woman Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Household Affected:<span style="font-weight:bold;"> /</span></p>';
            content.innerHTML += '<p>Total Death:<span style="font-weight:bold;"> /</span></p>';
        }
      }
         });
      //REMOVE ALL LAYERS
      for(var i=0;i < this.layerToManage.length;i++){
           this.map.removeLayer(this.layerToManage[i]);
      }
        /*Transparent layer*/
      var transparentLayerSource = new VectorSource({
        features: new GeoJSON().readFeatures(laosData),
        format: new GeoJSON(),
        crossOrigin: 'anonymous'
      });

      var transparentLayer = new VectorLayer({
        renderMode: 'image',
        source: transparentLayerSource,
        style: styleTransparentFunction
      });

      function styleTransparentFunction(feature, resolution) {

        return [
          new Style({
              fill: new Fill({
                color: '#ff000000'
              }),
              stroke: new Stroke({
                color: '#ff000000',
                width: 1,
              })
            })
        ];

      }

      /***************** PROJECT CASE*******************************/
      if(category === 'Project'){
      
        //Province
        var laosSource = new VectorSource({
          features: new GeoJSON().readFeatures(laosData),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        this.laosLayer = new VectorLayer({
          renderMode: 'image',
          source: laosSource,
          style: styleLaosFunction
        });

        var defaultStyleLaos = new Style({
          fill: new Fill({
            color: 'white',
          }),
          stroke: new Stroke({
            color: '#DCDCDC',
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleLaosFunction(feature, resolution) {
          return [defaultStyleLaos];
        }

        this.layerToManage.push(this.laosLayer);
        this.map.addLayer(this.laosLayer);

        //LOCATION ICON LAYER
        var projectLocation = [
          [102.2, 21.7],
          [101.1, 20.9],
          [100.6, 20.4],
          [101.8, 20.4],
          [102.6, 20],
          [104, 20.4],
          [101.4, 19],
          [102.2, 18.8],
          [103, 18.8],
          [102.7, 18],
          [103.4, 19.5],
          [104.4, 18.5],
          [105.4, 17.5],
          [105.8, 16.5],
          [106.3, 15.8],
          [105.8, 14.8],
          [107.1, 14.8],
          [107, 15.6]
        ];
        var projectValue = [
          '', '', '', '', '1', '', '', '2', '', '1', '', '', '', '', '', '', '', ''
        ];
        var projectWidth = [
          0, 0, 0, 0, 0.15, 0, 0, 0.20, 0, 0.15, 0, 0, 0 , 0 , 0, 0, 0, 0
        ];

        const iconProjectSource = new VectorSource({
          features: [],
        });

        this.iconProjectLayer = new VectorLayer({
          source: iconProjectSource,
        });

        for(let i = 0; i < projectLocation.length; i++){

          const iconProjectFeature = new Feature({
            geometry: new Point(projectLocation[i]),
            name: 'Luang Prabang'
          });
          const iconProjectStyle = new Style({
            text: new Text({
                   text: projectValue[i],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                   width: 2,
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconProjectFeature.setStyle(iconProjectStyle);
          this.iconProjectLayer.getSource().addFeature(iconProjectFeature);

        }

        this.layerToManage.push(this.iconProjectLayer);
        this.map.addLayer(this.iconProjectLayer);

        for(let i = 0; i < projectLocation.length; i++){
          this.circleProjectLayer = new VectorLayer({
            source: new VectorSource({
              features: [new Feature(new Circle(projectLocation[i],projectWidth[i]))]
            }),
            style: [
                    new Style({
                      stroke: new Stroke({
                        color: 'rgb(233, 30, 99, 0.5)',
                        width: 1
                      }),
                      fill: new Fill({
                        color: 'rgb(233, 30, 99, 0.5)'
                      })
                    })
                  ]
          }); 
          this.layerToManage.push(this.circleProjectLayer);
          this.map.addLayer(this.circleProjectLayer);
        }

      }


      /***************** ASSET CASE*******************************/
      if(category === 'Asset'){

        var laosSource = new VectorSource({
          features: new GeoJSON().readFeatures(laosData),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        //Province 
        this.laosLayer = new VectorLayer({
          renderMode: 'image',
          source: laosSource,
          style: styleLaosFunction
        });

        var defaultStyleLaos = new Style({
          fill: new Fill({
            color: 'white',
          }),
          stroke: new Stroke({
            color: '#DCDCDC',
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleLaosFunction(feature, resolution) {
          return [defaultStyleLaos];
        }

        //ROAD LAYER
        var roadSource = new VectorSource({
          features: new GeoJSON().readFeatures(roadData),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        this.roadLayer = new VectorLayer({
          renderMode: 'image',
          source: roadSource,
          style: styleRoadFunction
        });

        var defaultStyleRoad = new Style({
          fill: new Fill({
            color: '#e67300',
          }),
          stroke: new Stroke({
            color: '#e67300',
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleRoadFunction(feature, resolution) {
          return [defaultStyleRoad];
        }

        //SCHOOL LAYER
        const iconSchoolSource = new VectorSource({
          features: [],
        });

        this.iconSchoolLayer = new VectorLayer({
          source: iconSchoolSource,
        });

        //for(let i = 0; i < stationLocation.length; i++){

          const iconSchoolFeature = new Feature({
            geometry: new Point([ 104.8, 16.6 ]/*fromLonLat( [ 20.329, 100.192 ] , "EPSG:4326", "EPSG:3857")*/),
            id: /*i+*/1,
            name: 'Savannakhet'
          });
          const iconSchoolStyle = new Style({
            text: new Text({
                   text: '', //stationLocation[i][3],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                 
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconSchoolFeature.setStyle(iconSchoolStyle);
          this.iconSchoolLayer.getSource().addFeature(iconSchoolFeature);

          //for(let j =0; j < stationLocation.length; j++) {
              this.circleShoolLayer = new VectorLayer({
                source: new VectorSource({
                features: [new Feature(new Circle([ 104.8, 16.6 ]))]
              }),
                style: [
                        new Style({
                          stroke: new Stroke({
                            color: 'rgba(60, 222, 103, 1)',
                            width: 1
                          }),
                          fill: new Fill({
                            color: 'rgba(60, 222, 103, 0.5)'
                          })
                        })
                      ]
                }); 
          //}
        //}


        //HOSPITAL LAYER
        const iconHospitalSource = new VectorSource({
          features: [],
        });

        this.iconHospitalLayer = new VectorLayer({
          source: iconHospitalSource,
        });

        //for(let i = 0; i < stationLocation.length; i++){

        const iconHospitalFeature = new Feature({
          geometry: new Point([102.2, 19.9]),
          name: 'Luang Prabang'
        });
        const iconHospitalStyle = new Style({
          text: new Text({
                 text: '1',
                 font: 'bold 17px Calibri,sans-serif',
                 fill: new Fill({ color: 'black' }),
                 color: '#fff', 
                 width: 1,
                 textAlign: 'center',
                 textBaseline: 'hanging',               
                 offsetX : 0,
                 offsetY : -5,           
                 declutter: true,
                 overflow: true
         })
        });
        iconHospitalFeature.setStyle(iconHospitalStyle);
        this.iconHospitalLayer.getSource().addFeature(iconHospitalFeature);

        this.circleHospitalLayer = new VectorLayer({
          source: new VectorSource({
            features: [new Feature(new Circle([ 102.2, 19.9 ],0.15))]
          }),
          style: [
                  new Style({
                    stroke: new Stroke({
                      color: 'rgba(45, 161, 76)',
                      width: 1
                    }),
                    fill: new Fill({
                      color: 'rgba(45, 161, 76, 0.5)'
                    })
                  })
                ]
        }); 


        //BRIDGE LAYER
        const iconBridgeSource = new VectorSource({
          features: [],
        });

        this.iconBridgeLayer = new VectorLayer({
          source: iconBridgeSource,
        });

        const iconBridgeFeature = new Feature({
          geometry: new Point([104.2, 19.9]),
          name: 'Luang Prabang'
        });
        const iconBridgeStyle = new Style({
          text: new Text({
                 text: '1',
                 font: 'bold 17px Calibri,sans-serif',
                 fill: new Fill({ color: 'black' }),
                 color: '#fff', 
                 width: 0.15,
                 textAlign: 'center',
                 textBaseline: 'hanging',               
                 offsetX : 0,
                 offsetY : -5,           
                 declutter: true,
                 overflow: true
         })
        });
        iconBridgeFeature.setStyle(iconBridgeStyle);
        this.iconBridgeLayer.getSource().addFeature(iconBridgeFeature);

        this.circleBridgeLayer = new VectorLayer({
          source: new VectorSource({
            features: [new Feature(new Circle([ 104.2, 19.9 ],0.15))]
          }),
          style: [
                  new Style({
                    stroke: new Stroke({
                      color: 'rgb(233, 30, 99)',
                      width: 1
                    }),
                    fill: new Fill({
                      color: 'rgb(233, 30, 99, 0.5)'
                    })
                  })
                ]
        }); 


        //IRRIGATION LAYER
        var irrigationLocation = [
          [102.2, 21.9],
          [100.2, 20.5]
        ];
        var irrigationValue = [
          '1'
        ];
        var irrigationWidth = [
          0.15
        ];

        const iconIrrigationSource = new VectorSource({
          features: [],
        });

        this.iconIrrigationLayer = new VectorLayer({
          source: iconIrrigationSource,
        });

        for(let i = 0; i < irrigationLocation.length; i++){

          const iconIrrigationFeature = new Feature({
            geometry: new Point(irrigationLocation[i]),
            name: 'Luang Prabang'
          });
          const iconIrrigationStyle = new Style({
            text: new Text({
                   text: irrigationValue[i],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                   width: 2,
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconIrrigationFeature.setStyle(iconIrrigationStyle);
          this.iconIrrigationLayer.getSource().addFeature(iconIrrigationFeature);

        }


        this.layerToManage.push(this.laosLayer);
        this.layerToManage.push(this.roadLayer);
        this.layerToManage.push(this.iconSchoolLayer);
        this.layerToManage.push(this.circleShoolLayer);
        this.layerToManage.push(this.iconHospitalLayer);
        this.layerToManage.push(this.circleHospitalLayer);
        this.layerToManage.push(this.iconIrrigationLayer);
        this.layerToManage.push(this.circleBridgeLayer);
        this.layerToManage.push(this.iconBridgeLayer);

        this.map.addLayer(this.laosLayer);
        this.map.addLayer(this.roadLayer);
        this.map.addLayer(this.iconSchoolLayer);
        this.map.addLayer(this.circleShoolLayer);
        this.map.addLayer(this.iconHospitalLayer);
        this.map.addLayer(this.circleHospitalLayer);
        this.map.addLayer(this.iconIrrigationLayer);
        this.map.addLayer(this.circleBridgeLayer);
        this.map.addLayer(this.iconBridgeLayer);


        //Irrigation Circle
        for(let i = 0; i < irrigationLocation.length; i++){
          this.circleIrrigationLayer = new VectorLayer({
            source: new VectorSource({
              features: [new Feature(new Circle(irrigationLocation[i],irrigationWidth[i]))]
            }),
            style: [
                    new Style({
                      stroke: new Stroke({
                        color: 'rgb(0, 87, 217, 0.5)',
                        width: 1
                      }),
                      fill: new Fill({
                        color: 'rgb(0, 87, 217, 0.5)'
                      })
                    })
                  ]
          }); 
          this.layerToManage.push(this.circleIrrigationLayer);
          this.map.addLayer(this.circleIrrigationLayer);
        }

    }


      /***************** DISASTER CASE*******************************/
      if(category === 'Disaster'){
      
        //Province
        var laosSource = new VectorSource({
          features: new GeoJSON().readFeatures(laosData),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        this.laosLayer = new VectorLayer({
          renderMode: 'image',
          source: laosSource,
          style: styleLaosFunction
        });

        var defaultStyleLaos = new Style({
          fill: new Fill({
            color: 'white',
          }),
          stroke: new Stroke({
            color: '#DCDCDC',
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleLaosFunction(feature, resolution) {
          return [defaultStyleLaos];
        }
      
        this.layerToManage.push(this.laosLayer);
        this.map.addLayer(this.laosLayer);

        //LOCATION ICON LAYER
        var projectLocation = [
          [102.2, 21.7],
          [101.1, 20.9],
          [100.6, 20.4],
          [101.8, 20.4],
          [102.6, 20],
          [104, 20.4],
          [101.4, 19],
          [102.2, 18.8],
          [103, 18.8],
          [102.7, 18],
          [103.4, 19.5],
          [104.4, 18.5],
          [105.4, 17.5],
          [105.8, 16.5],
          [106.3, 15.8],
          [105.8, 14.8],
          [107.1, 14.8],
          [107, 15.6]
        ];
        var projectValue = [
          '', '', '', '', '3', '', '', '', '', '1', '', '', '', '', '', '', '', ''
        ];
        var projectWidth = [
          0, 0, 0, 0, 0.22, 0, 0, 0, 0, 0.15, 0, 0, 0 , 0 , 0, 0, 0, 0
        ];

        const iconProjectSource = new VectorSource({
          features: [],
        });

        this.iconProjectLayer = new VectorLayer({
          source: iconProjectSource,
        });

        for(let i = 0; i < projectLocation.length; i++){

          const iconProjectFeature = new Feature({
            geometry: new Point(projectLocation[i]),
            name: 'Luang Prabang'
          });
          const iconProjectStyle = new Style({
            text: new Text({
                   text: projectValue[i],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                   width: 2,
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconProjectFeature.setStyle(iconProjectStyle);
          this.iconProjectLayer.getSource().addFeature(iconProjectFeature);

        }

        this.layerToManage.push(this.iconProjectLayer);
        this.map.addLayer(this.iconProjectLayer);

        for(let i = 0; i < projectLocation.length; i++){
          this.circleProjectLayer = new VectorLayer({
            source: new VectorSource({
              features: [new Feature(new Circle(projectLocation[i],projectWidth[i]))]
            }),
            style: [
                    new Style({
                      stroke: new Stroke({
                        color: 'rgb(255, 124, 0, 0.5)',
                        width: 1
                      }),
                      fill: new Fill({
                        color: 'rgb(255, 124, 0, 0.5)'
                      })
                    })
                  ]
          }); 
          this.layerToManage.push(this.circleProjectLayer);
          this.map.addLayer(this.circleProjectLayer);
        }



      }


      /***************** LOCATION CASE*******************************/
      if(category === 'Location'){
      
        //Province
        var laosSource = new VectorSource({
          features: new GeoJSON().readFeatures(laosData),
          format: new GeoJSON(),
          crossOrigin: 'anonymous'
        });

        this.laosLayer = new VectorLayer({
          renderMode: 'image',
          source: laosSource,
          style: styleLaosFunction
        });

        var defaultStyleLaos = new Style({
          fill: new Fill({
            color: 'white',
          }),
          stroke: new Stroke({
            color: '#DCDCDC',
            width: 1,
          })
        });

        // the style function returns an array of styles for the given feature and resolution.
        // Return null to hide the feature.
        function styleLaosFunction(feature, resolution) {
          return [defaultStyleLaos];
        }
      
        this.layerToManage.push(this.laosLayer);
        this.map.addLayer(this.laosLayer);

        //LOCATION ICON LAYER
        var projectLocation = [
          [102.2, 21.7],
          [101.1, 20.9],
          [100.6, 20.4],
          [101.8, 20.4],
          [102.6, 20],
          [104, 20.4],
          [101.4, 19],
          [102.2, 18.8],
          [103, 18.8],
          [102.7, 18],
          [103.4, 19.5],
          [104.4, 18.5],
          [105.4, 17.5],
          [105.8, 16.5],
          [106.3, 15.8],
          [105.8, 14.8],
          [107.1, 14.8],
          [107, 15.6]
        ];
        var projectValue = [
          '40', '4', '24', '12', '16', '4', '32', '36', '12', '16', '12', '12', '32', '16', '4', '12', '12', '4'
        ];
        var projectWidth = [
          0.5, 0.05, 0.3, 0.15, 0.2, 0.05, 0.4, 0.45, 0.15, 0.2, 0.15, 0.15, 0.4 , 0.2 , 0.05, 0.15, 0.15, 0.05
        ];

        const iconProjectSource = new VectorSource({
          features: [],
        });

        this.iconProjectLayer = new VectorLayer({
          source: iconProjectSource,
        });

        for(let i = 0; i < projectLocation.length; i++){

          const iconProjectFeature = new Feature({
            geometry: new Point(projectLocation[i]),
            name: 'Luang Prabang'
          });
          const iconProjectStyle = new Style({
            text: new Text({
                   text: projectValue[i],
                   font: 'bold 17px Calibri,sans-serif',
                   fill: new Fill({ color: 'black' }),
                   color: '#fff', 
                   width: 2,
                   textAlign: 'center',
                   textBaseline: 'hanging',               
                   offsetX : 0,
                   offsetY : -5,           
                   declutter: true,
                   overflow: true
           })
          });
          iconProjectFeature.setStyle(iconProjectStyle);
          this.iconProjectLayer.getSource().addFeature(iconProjectFeature);

        }

        this.layerToManage.push(this.iconProjectLayer);
        this.map.addLayer(this.iconProjectLayer);

        for(let i = 0; i < projectLocation.length; i++){
          this.circleProjectLayer = new VectorLayer({
            source: new VectorSource({
              features: [new Feature(new Circle(projectLocation[i],projectWidth[i]))]
            }),
            style: [
                    new Style({
                      stroke: new Stroke({
                        color: 'rgb(233, 30, 99, 0.5)',
                        width: 1
                      }),
                      fill: new Fill({
                        color: 'rgb(233, 30, 99, 0.5)'
                      })
                    })
                  ]
          }); 
          this.layerToManage.push(this.circleProjectLayer);
          this.map.addLayer(this.circleProjectLayer);
        }
      }

      this.map.addLayer(transparentLayer);

      //console.log(this.map.getOverlays());

    }//end of update function






  }
}
</script>

<style>
  .row {
    margin: 0px;
  }
  .pd-0 {
    padding: 7px;
  }
  .v-application p {
      margin-bottom: 5px;
      font-size: 13px;
  }
  #information {
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    font-size: 10px;
    color: #212121;
    z-index: 100;
    position: relative;
    padding: 5px;
  }

  #marker {
    width: 20px;
    height: 20px;
    opacity: 1;
  }

  .ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 310px;
  }
  .ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  .ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
  }
  .ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
  }
  .ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
  }
  .ol-popup-closer:after {
    content: "✖";
  }

</style>
